export enum MonetizableType {
  NO = 'no',
  NO_BECAUSE_OF_LEAD = 'no_because_of_lead',
  NO_BECAUSE_OF_LIMIT = 'no_because_of_limit',
  YES_ASSUMED = 'yes_assumed',
  NO_BECAUSE_OF_LEAD_FORM = 'no_because_of_lead_form',
  NO_BECAUSE_OF_DETAILS = 'no_because_of_details',
}

export const ALL_MONETIZABLE_TYPES = Object.values(MonetizableType);
